import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PrevIcon from '@moda/icons/prev-24';
import { Clickable } from '@moda/om';
import { hrefFor } from '../../../../routers';

export const DesktopLookviewPagePrevIcon = () => {
  const { vertical, trunkshowSlug } = useParams<{
    vertical: string;
    trunkshowSlug: string;
  }>();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnTo = searchParams.get('returnTo');

  const defaultTo = hrefFor.TrunkshowPage({ vertical, trunkshowSlug });
  const to = returnTo ? `/${returnTo}` : `${defaultTo}?mode=basic`;

  return (
    <Clickable to={to}>
      <PrevIcon />
    </Clickable>
  );
};
